<template>
    <div class="row-wrapper">
        <trial-over @close-modal="hide_trial_modal" v-if="trial_modal_shown" :shown="trial_modal_shown"></trial-over>
        <a
            :class="{
                'people-item': true,
                'not-attending': ['not_attending', 'pending'].includes(event_person.status)
            }"
            href="javascript:{}"
            @click="go_to_person(event_person.person.id)"
        >
            <div class="people-item-icon">
                <div v-if="event_person.person.avatar_url">
                    <div
                        class="person-logo"
                        :style="{
                            backgroundImage: `url('${settings.api_url + '/resource/avatar/' + event_person.person.id}')`
                        }"
                    ></div>
                </div>
                <div v-else>
                    <div class="people-item-icon-container" v-if="event_person.person.gender">
                        <span
                            v-if="event_person.person.age_group == 'adult'"
                            :class="{
                                'icon-man': event_person.person.gender === 'man',
                                'icon-woman': event_person.person.gender === 'woman'
                            }"
                        ></span>
                        <span
                            v-else
                            :class="{
                                'icon-boy': event_person.person.gender === 'man',
                                'icon-girl': event_person.person.gender === 'woman'
                            }"
                        ></span>
                    </div>
                    <div class="people-item-icon-container" v-else>
                        <span :class="{ 'icon-man': true }" v-if="event_person.person.age_group == 'adult'"></span>
                        <span :class="{ 'icon-boy': true }" v-else></span>
                    </div>
                </div>
            </div>
            <div class="people-item-content">
                <div class="people-item-content-top">
                    {{ event_person.person.first_name }} {{ event_person.person.last_name }}
                </div>
                <div class="people-item-content-bottom">
                    <div class="people-item-socials">
                        <a v-if="event_person.person.phone" :href="'tel:' + event_person.person.phone">
                            <span class="icon-phone"></span>
                        </a>
                        <a
                            href="javascript:{}"
                            v-if="event_person.person.email"
                            :href="'mailto:' + event_person.person.email"
                        >
                            <span class="icon-envelope"></span>
                        </a>
                        <a
                            target="_blank"
                            href="javascript:{}"
                            v-if="event_person.person.facebook"
                            :href="event_person.person.facebook"
                        >
                            <span class="icon-fb"></span>
                        </a>
                    </div>
                </div>
            </div>
        </a>

        <div class="events-group-item--right">
            <div :class="{ 'drop menu-more': true, show: drop_shown }" v-click-outside="away">
                <a @click="open_drop" href="javascript:{}"><span class="icon icon-dots"></span></a>
                <div class="drop-content">
                    <ul>
                        <li>
                            <a @click.stop="change_event_attending_status('attending')" href="javascript:{}"
                                >Attending</a
                            >
                        </li>
                        <li>
                            <a
                                class="red"
                                @click.stop="change_event_attending_status('not_attending')"
                                href="javascript:{}"
                                >Not Attending</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
            <div class="people-item-right"></div>
        </div>
    </div>
</template>

<script>
import router from "@/router";
import settings from "@/settings";
import vClickOutside from "v-click-outside";
import { mapActions, mapState } from "vuex";
import TrialOver from "./../../trial-over-modal.vue";

export default {
    name: "people-group",
    props: ["event_person"],
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            trial_modal_shown: false,
            drop_shown: false,
            settings: settings
        };
    },
    computed: {
        ...mapState(["user"])
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            next();
        });
    },
    components: {
        TrialOver
    },
    methods: {
        ...mapActions("StoreEvent", ["change_person_event_status"]),
        ...mapActions(["get_logged_in_user"]),
        change_event_attending_status(status) {
            this.away();
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                let payload = {
                    status: status,
                    event_person: this.event_person
                };
                this.change_person_event_status(payload);
            } else {
                this.trial_modal_shown = true;
            }
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },
        open_drop() {
            this.drop_shown = !this.drop_shown;
        },
        go_to_person(person_id) {
            if (person_id) {
                router.push({ path: "/people/" + person_id });
            }
        },
        away() {
            if (this.drop_shown) {
                this.drop_shown = false;
            }
        }
    }
};
</script>

<style scoped>
.person-logo {
    width: 3.2rem;
    background-size: cover;
    height: 3.2rem;
    border-radius: 50%;
    background-position: 50% 50%;
    display: inline-block;
    background-repeat: no-repeat;
}

.people-item-content {
    flex: 1;
}

.people-item {
    flex: 1;
}

.people-item.not-attending .people-item-content,
.people-item.not-attending .people-item-icon {
    opacity: 0.3;
}

.row-wrapper {
    display: flex;
    border-bottom: 0.1rem solid #e6e6e6;
}

.drop {
    align-items: flex-start;
    flex: initial;
    display: block;
    height: initial;
    margin-top: 1.2rem;
}

.people-item {
    border: none;
}

.people-item-right {
    margin-bottom: 1.2rem;
}

.events-group-item--right {
    display: flex;
    text-align: right;
    flex-direction: column;
    margin-top: -0.6rem;
}
</style>
